<template>
  <header id="header" class="container">
    <div class="columns is-centered">
      <div class="logo column is-one-quarter">
        <figure class="image is-96x96 is-pulled-left">
          <img class="is-rounded has-background-white" src="../assets/logo-192x192.png" />
        </figure>
        <h1 class="title is-1 is-pulled-left">COTIZR</h1>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CotizrHeader'
}
</script>

<style lang="scss" scoped>
#header {
  padding-top: 2rem;
}

.logo {
  margin-top: 0.75rem;
}

.title {
  color: white;
  margin-top: 17px;
  margin-left: 1rem;
}
</style>
